/* eslint-disable react/jsx-key */
import {
  DataGrid,
  GridCallbackDetails,
  GridRowIdGetter,
  GridRowParams,
  GridSortModel,
  MuiEvent,
  ptBR
} from '@mui/x-data-grid'

import './style.css'
import { useTableContext } from './table.context'

interface TableProps {
  columns: any
  rows: any
  style?: any
  checkboxSelection: boolean
  rowHeight?: number
  getRowId?: GridRowIdGetter
  getRowClassName?: any
  onRowClick?: (
    params: GridRowParams<{
      [key: string]: any
    }>,
    event: MuiEvent<React.SyntheticEvent<Element, Event>>,
    details: GridCallbackDetails
  ) => void
  rowCount?: number
  loading?: boolean
  className?: string
  sortModel?: GridSortModel
  onSortModelChange?: (
    model: GridSortModel,
    details: GridCallbackDetails
  ) => void
}

export const Table = (props: TableProps) => {
  const {
    rows,
    columns,
    checkboxSelection,
    style,
    rowHeight,
    getRowId,
    getRowClassName,
    onRowClick,
    rowCount,
    loading,
    className,
    sortModel,
    onSortModelChange
  } = props

  const { pagination, handlePageChange, handlePageSizeChange } =
    useTableContext()

  const columnFields = columns?.map((col: any) => col.field) || []
  const safeSortModel = sortModel?.filter((item: any) =>
    columnFields.includes(item.field)
  )

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        ...style
      }}
    >
      <DataGrid
        onRowClick={onRowClick}
        rows={rows || []}
        rowCount={rowCount}
        loading={loading}
        columns={columns}
        paginationMode="server"
        sortingMode="server"
        filterMode="server"
        rowsPerPageOptions={[10, 50, 100]}
        pageSize={pagination.limit}
        page={pagination.page}
        onPageSizeChange={handlePageSizeChange}
        onPageChange={handlePageChange}
        getRowId={getRowId}
        getRowClassName={getRowClassName}
        disableColumnMenu={true}
        rowHeight={rowHeight}
        checkboxSelection={checkboxSelection}
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        style={{ background: 'white', ...style }}
        className={className}
        sortModel={safeSortModel}
        onSortModelChange={onSortModelChange}
      />
    </div>
  )
}

Table.defaultProps = {
  checkboxSelection: false,
  rowHeight: 44
}
